<!-- Hero Start -->
<section class="bg-half-170 bg-light d-table w-100 d-print-none" id="home">
  <div class="container">
    <div class="row mt-5 justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="pages-heading">
          <h4 class="title"> Privacy Policy </h4>
          <!-- <ul class="list-unstyled mt-4 mb-0">
            <li class="list-inline-item h6 date text-muted">
              <span class="text-dark">Last Revised :</span> {{ lastRevised }}
            </li>
          </ul> -->
        </div>
      </div>
    </div>

    <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/index">Blimp</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">Page</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">Utility</a></li>
          <li class="breadcrumb-item active" aria-current="page">Privacy</li>
        </ul>
      </nav>
    </div>
  </div>
</section>
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- Shape End -->

<!-- Start Privacy -->
<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <div class="card shadow rounded border-0">
          <div class="card-body">

            <h5 class="card-title">Overview :</h5>
            <p class="text-muted">
              At <strong>BLMPI Tourism</strong>, your privacy is at the heart of everything we do.
              This policy explains how we collect, use and protect your personal information across
              all of our services: <strong>Adventures, Camping, Foods, Souvenirs and Visas</strong>.
              We are committed to full transparency and to giving you complete control over your data.
            </p>
            <p class="text-muted">
              Whether you're booking a mountain expedition, reserving a campsite, ordering a local dish,
              buying a souvenir or applying for a travel visa — the same strict privacy standards apply.
            </p>
            <p class="text-muted">
              By using any BLMPI service, you agree to the practices described in this Privacy Policy.
            </p>

            <h5 class="card-title">We use your information to :</h5>
            <ul class="list-unstyled text-muted">
              <li>
                <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                Confirm and manage bookings across Adventures, Camping & Visas
              </li>
              <li>
                <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                Personalize your culinary and souvenir experience
              </li>
              <li>
                <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                Send safety updates and travel alerts
              </li>
              <li>
                <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                Process secure payments and prevent fraud
              </li>
              <li>
                <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                Improve our services through anonymized analytics
              </li>
              <li>
                <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                Provide 24/7 customer support when you need it
              </li>
            </ul>

            <h5 class="card-title">Information Provided Voluntarily :</h5>
            <p class="text-muted">
              When you sign up, book a trip, submit a story, or apply for a visa through BLMPI,
              you voluntarily provide personal information such as your name, contact details and
              travel documents. This data is encrypted, stored securely and only accessible to
              authorized BLMPI staff. You may request access, correction or deletion of your data
              at any time by contacting <a href="mailto:privacy&#64;blmpi.com">privacy&#64;blmpi.com</a>.
            </p>

            <a href="javascript:window.print()" class="btn btn-soft-primary d-print-none">Print</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Privacy -->
<!-- Start Account Deletion Section -->
<section class="section pt-0 d-print-none" id="account-deletion">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <div class="card shadow rounded border-0">
          <div class="card-body">

            <h5 class="card-title">Account Deletion :</h5>

            <p class="text-muted">{{ deletionInfo.intro }}</p>

            <!-- Steps -->
            <h6 class="fw-bold mt-4 mb-3">How to delete your account :</h6>
            <ol class="text-muted ps-3">
              <li class="mb-2" *ngFor="let step of deletionSteps">{{ step }}</li>
            </ol>

            <!-- Screenshot placeholder / hint -->
            <div class="alert alert-soft-primary d-flex align-items-center mt-3" role="alert">
              <i-feather name="smartphone" class="fea icon-sm me-2"></i-feather>
              <span>
                The <strong>"Delete Account"</strong> button is available on the
                <strong>Profile</strong> page inside the BLMPI mobile app for both
                <strong>Android</strong> and <strong>iOS</strong>.
              </span>
            </div>

            <!-- Warning -->
            <div class="alert alert-soft-danger d-flex align-items-start mt-3" role="alert">
              <i-feather name="alert-triangle" class="fea icon-sm me-2 mt-1"></i-feather>
              <span>{{ deletionInfo.warning }}</span>
            </div>

            <!-- Data Deleted -->
            <h6 class="fw-bold mt-4 mb-2">Data that will be deleted :</h6>
            <ul class="list-unstyled text-muted">
              <li *ngFor="let item of deletionInfo.dataDeleted">
                <i-feather name="check-circle" class="fea icon-sm me-2 text-success"></i-feather>
                {{ item }}
              </li>
            </ul>

            <!-- Data Retained -->
            <h6 class="fw-bold mt-4 mb-2">Data we may retain :</h6>
            <ul class="list-unstyled text-muted">
              <li *ngFor="let item of deletionInfo.dataRetained">
                <i-feather name="info" class="fea icon-sm me-2 text-warning"></i-feather>
                {{ item }}
              </li>
            </ul>

            <!-- Processing Time -->
            <p class="text-muted mt-3 mb-2">
              <i-feather name="clock" class="fea icon-sm me-2"></i-feather>
              {{ deletionInfo.processingTime }}
            </p>

            <!-- Support -->
            <p class="text-muted mb-0">
              <i-feather name="mail" class="fea icon-sm me-2"></i-feather>
              If you face any issue during deletion, contact us at
              <a [href]="'mailto:' + deletionInfo.supportEmail">
                {{ deletionInfo.supportEmail }}
              </a>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Account Deletion Section -->

<!-- Start Story Deletion Section -->
<section class="section pt-0 d-print-none" id="story-deletion">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <div class="card shadow rounded border-0">
          <div class="card-body">

            <h5 class="card-title">Story Deletion :</h5>

            <p class="text-muted">{{ storyDeletionInfo.intro }}</p>

            <!-- Steps -->
            <h6 class="fw-bold mt-4 mb-3">How to delete your story :</h6>
            <ol class="text-muted ps-3">
              <li class="mb-2" *ngFor="let step of storyDeletionInfo.steps">{{ step }}</li>
            </ol>

            <!-- Hint -->
            <div class="alert alert-soft-primary d-flex align-items-center mt-3" role="alert">
              <i-feather name="smartphone" class="fea icon-sm me-2"></i-feather>
              <span>
                Simply <strong>long press</strong> on your story inside the BLMPI mobile app
                and the <strong>"Delete Story"</strong> option will appear in a quick menu.
              </span>
            </div>

            <!-- Warning -->
            <div class="alert alert-soft-danger d-flex align-items-start mt-3" role="alert">
              <i-feather name="alert-triangle" class="fea icon-sm me-2 mt-1"></i-feather>
              <span>{{ storyDeletionInfo.warning }}</span>
            </div>

            <!-- Note -->
            <p class="text-muted mt-3 mb-2">
              <i-feather name="info" class="fea icon-sm me-2"></i-feather>
              {{ storyDeletionInfo.note }}
            </p>

            <!-- Support -->
            <p class="text-muted mb-0">
              <i-feather name="mail" class="fea icon-sm me-2"></i-feather>
              If you face any issue deleting your story, contact us at
              <a [href]="'mailto:' + storyDeletionInfo.supportEmail">
                {{ storyDeletionInfo.supportEmail }}
              </a>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Story Deletion Section -->
<!-- Start Services Policy Sections -->
<section class="section pt-0">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <h5 class="card-title mb-3">Data We Collect per Service :</h5>

        <div class="accordion" id="policyAccordion">
          <div class="card shadow rounded border-0 mb-3" *ngFor="let section of policySections; let i = index">
            <div class="card-header bg-white border-0" [id]="'heading' + i">
              <h2 class="mb-0">
                <button
                  class="btn btn-link text-dark text-decoration-none w-100 text-start fw-bold"
                  type="button"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#collapse' + i"
                  [attr.aria-expanded]="i === 0"
                  [attr.aria-controls]="'collapse' + i">
                  {{ section.title }}
                </button>
              </h2>
            </div>
            <div
              [id]="'collapse' + i"
              class="collapse"
              [class.show]="i === 0"
              [attr.aria-labelledby]="'heading' + i"
              data-bs-parent="#policyAccordion">
              <div class="card-body">
                <p class="text-muted">{{ section.description }}</p>
                <ul class="list-unstyled text-muted mb-0">
                  <li *ngFor="let p of section.points">
                    <i-feather name="arrow-right" class="fea icon-sm me-2"></i-feather>
                    {{ p }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Services Policy Sections -->



<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top"
   [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->